import { render, staticRenderFns } from "./VSorter.vue?vue&type=template&id=5c9a27af&"
import script from "./VSorter.vue?vue&type=script&lang=js&"
export * from "./VSorter.vue?vue&type=script&lang=js&"
import style0 from "./VSorter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports